import type { DeltaKind } from '@airreading/sync/delta';
import type { EntityType } from '@airreading/sync/association';

export type NormalizedEntityItem = {
  type: EntityType;
  kind: DeltaKind;
  internalId?: string;
  externalId?: string;
  label?: string;
  details?: Record<string, string | null>;
};

const EXCLUDED_DETAIL_KEYS = ['id', 'orgId', 'externalId', 'kind', 'edlinkId'];
const EMPTY_VALUE = '(empty)';

export const cleanEntityItemDetails = (details: Record<string, unknown>): Record<string, string> => {
  return Object.fromEntries(
    Object.entries(details).flatMap(([k, v]) => {
      if (v === undefined || EXCLUDED_DETAIL_KEYS.includes(k)) {
        return [];
      }

      if (v === null) {
        return [[k, EMPTY_VALUE]];
      }

      if (typeof v === 'object') {
        return Object.entries(v as Record<string, unknown>).flatMap(([nestedK, nestedV]) => {
          if (nestedV === undefined) {
            return [];
          }

          let rendered: string;

          if (nestedV === null) {
            rendered = EMPTY_VALUE;
          } else if (typeof nestedV === 'object') {
            rendered = JSON.stringify(nestedV);
          } else {
            rendered = String(nestedV);
          }

          return [[`${k}.${nestedK}`, rendered]];
        });
      }

      return [[k, String(v)]];
    }),
  );
};
